// extracted by mini-css-extract-plugin
export default {"box":"blogsListPage_box__Kh7fV"};